module.exports = __webpack_public_path__ + "static/media/steering-wheel.a8cdf01d.svg";